import { Component } from 'san';
import { IWorkflowStep } from 'src/models';

export default class WorkflowStepTip extends Component {
  constructor(options: any) {
    super(options);
  }

  initData(): {
    checkEnable: boolean;
    isNew: boolean;
    isShowArrow: boolean;
    name: string;
    data: IWorkflowStep;
    todo: boolean;
    done: boolean;
  } {
    return {
      checkEnable: false,
      isNew: false,
      isShowArrow: false,
      name: '',
      data: null,
      todo: false,
      done: false,
    };
  }

  inited() { }

  check() {
    if (!this.data.get('checkEnable')) {
      return;
    }
    this.fire('check-change', this.data.get('data'));
  }

  addStepAfter() {
    this.fire('add-step', {
      location: 'after',
      step: this.data.get('data'),
    });
  }
}
